/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type BottomBar_navigation = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BottomBar_navigation",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SiteNav_navigation",
      "args": null
    }
  ],
  "type": "Navigation"
};

module.exports = fragment;
